import React from "react";
import { Link } from "react-router-dom";
import { Popover, OverlayTrigger } from "react-bootstrap";

export default function Action() {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Справка</Popover.Header>
      <Popover.Body>
        Квадратная кнопка справа нужна для сброса прогресса, с её помощью можно
        восстановить начальное состояние упражнения. Это полезно, если во время
        экспериментов что-то сломалось и не чинится. Не забудьте, что сброс
        удалит ваш код, поэтому сохраните его куда-нибудь перед сбросом.
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="lesson_actions p-3">
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button type="button" className="btn lesson_question">
          <span className="bi bi-question-circle fs-5"></span>
        </button>
      </OverlayTrigger>
      <div className="lesson_actions_row m-auto">
        <button className="me-3 btn btn-outline-secondary">
          <span className="bi bi-arrow-repeat"></span>
        </button>
        <Link to="#" className="btn btn-outline-secondary me-3">
          <span className="bi bi-arrow-left-short d-sm-none d-md-block d-lg-none"></span>
          <span className="d-none d-sm-block d-md-none d-lg-block">
            Предыдущий
          </span>
        </Link>
        <button className="me-3 d-inline-flex align-items-center btn btn-primary">
          <span className="bi bi-play-circle"></span>
          <span className="d-none d-sm-block d-md-none d-lg-block ms-1">
            Проверить
          </span>
        </button>
        <Link to="#" className="btn btn-outline-primary fw-normal disabled">
          <span className="bi bi-arrow-right-short d-sm-none d-md-block d-lg-none"></span>
          <span className="d-none d-sm-block d-md-none d-lg-block">
            Следующий
          </span>
        </Link>
      </div>
    </div>
  );
}
